export const SYNC_ATTEMPT = 'SYNC_ATTEMPT';
export const SYNC_SUCCESS = 'SYNC_SUCCESS';
export const SYNC_FAILURE = 'SYNC_FAILURE';
export const CLEAR_STATE = 'CLEAR_STATE';